const WhatWeDo = () => {

    return(
        <>
            <br />
            <div className="what-we-do-block row">
                <div className="white-text col">
                    <div className="container">
                        <h4 style={{"textDecoration": "underline"}}>To Prospective Members</h4>
                        <br />
                        <p>
                            We are always welcoming enthusiastic advanced undergraduate and beginning graduate students joining our group. While you will formally have a faculty member in our group as an advisor, we share most of activities such as seminars and journal clubs, also resources and office space together.
                        </p>
                        <p>
                            For the basic backgrounds to start doing research in our group, we expect you to have a solid course on quantum mechanics (roughly at the level of Sakurai), also some rudimentary knowledge of quantum field theory (at least Part I of Peskin & Schroeder). Our group members will also run various advanced courses during the semester, so please stay tuned.
                        </p>
                        <p>
                            Please feel free contacting any of us about possible undergraduate research and graduate study opportunities!
                        </p>
                        <br />
                    </div>
                </div>
            </div>
        </>
    )
}

export default WhatWeDo;